export default "__VITE_ASSET__DgYf$fBj__"